export const START_LOADER = 'START_LOADER';
export const STOP_LOADER = 'STOP_LOADER';

export const SET_REDRECT_TO_LOGIN_TRUE = 'SET_REDRECT_TO_LOGIN_TRUE';
export const SET_REDRECT_TO_LOGIN_FALSE = 'SET_REDRECT_TO_LOGIN_FALSE';

export const SET_PAGE_NO = 'SET_PAGE_NO';
export const SET_PAGE_LIMIT = 'SET_PAGE_LIMIT';
export const SET_PAGE_NO_1 = 'SET_PAGE_NO_1';
export const SET_PAGE_LIMIT_1 = 'SET_PAGE_LIMIT_1';
export const SET_SEARCH_KEYWORD = 'SET_SEARCH_KEYWORD';
export const SET_SEARCH_KEYWORD_1 = 'SET_SEARCH_KEYWORD_1';
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE';
export const SET_FILTER_STATUS = 'SET_FILTER_STATUS';
export const RESET_LISTING_STATES = 'RESET_LISTING_STATES';
